(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections-tab"] && !Shopify.designMode) return;
  try {
    
  let currentTab = 'tab1';
  let scrollPositions = {
    'tab1': 0, 'tab2': 0, 'tab3': 0, 'tab4': 0
  };

  let startX = 0, isDragging = false, startScrollPos = 0;

  function switchTab(tabId) {
    currentTab = tabId;
    
    // Remove active class from all buttons and contents
    document.querySelectorAll('.featured-collections-tabs .tab-button').forEach(btn => btn.classList.remove('active'));
    document.querySelectorAll('.featured-collections-tabs .tab-content').forEach(content => content.classList.remove('active'));
    
    // Add active class to selected button and content
    document.querySelector(`.featured-collections-tabs [data-tab="${tabId}"]`).classList.add('active');
    document.getElementById(tabId).classList.add('active');
  }

  function scrollProducts(direction) {
    const activeProductsGrid = document.getElementById(`products-${currentTab}`);
    if (!activeProductsGrid) return;
    
    const cardWidth = window.innerWidth <= 1200 ? 300 : 320;
    const visibleCards = window.innerWidth <= 768 ? 2 : 4;
    
    if (direction === 'next') {
      scrollPositions[currentTab] += cardWidth;
    } else {
      scrollPositions[currentTab] -= cardWidth;
    }
    
    const totalProducts = 8;
    const maxScroll = (totalProducts - visibleCards) * cardWidth;
    
    if (scrollPositions[currentTab] > maxScroll) {
      scrollPositions[currentTab] = 0;
    } else if (scrollPositions[currentTab] < 0) {
      scrollPositions[currentTab] = maxScroll;
    }
    
    activeProductsGrid.style.transform = `translateX(-${scrollPositions[currentTab]}px)`;
  }

  function addSwipeListeners() {
    const carousels = document.querySelectorAll('.products-viewport');
    carousels.forEach((carousel) => {
      carousel.addEventListener('mousedown', handleStart);
      carousel.addEventListener('mousemove', handleMove);
      carousel.addEventListener('mouseup', handleEnd);
      carousel.addEventListener('touchstart', handleStart, { passive: false });
      carousel.addEventListener('touchmove', handleMove, { passive: false });
      carousel.addEventListener('touchend', handleEnd);
    });
  }

  function handleStart(e) {
    isDragging = true;
    startScrollPos = scrollPositions[currentTab];
    startX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
    const activeProductsGrid = document.getElementById(`products-${currentTab}`);
    if (activeProductsGrid) activeProductsGrid.style.transition = 'none';
  }

  function handleMove(e) {
    if (!isDragging) return;
    const currentX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
    const deltaX = startX - currentX;
    if (Math.abs(deltaX) > 10) e.preventDefault();
    const activeProductsGrid = document.getElementById(`products-${currentTab}`);
    if (activeProductsGrid) {
      const newPos = startScrollPos + deltaX;
      activeProductsGrid.style.transform = `translateX(-${newPos}px)`;
    }
  }

  function handleEnd(e) {
    if (!isDragging) return;
    isDragging = false;
    const activeProductsGrid = document.getElementById(`products-${currentTab}`);
    if (activeProductsGrid) {
      activeProductsGrid.style.transition = 'transform 0.4s ease';
      const currentX = e.type === 'mouseup' ? e.clientX : (e.changedTouches ? e.changedTouches[0].clientX : startX);
      const deltaX = startX - currentX;
      if (Math.abs(deltaX) > 50) {
        if (deltaX > 0) scrollProducts('next');
        else scrollProducts('prev');
      } else {
        activeProductsGrid.style.transform = `translateX(-${scrollPositions[currentTab]}px)`;
      }
    }
  }

  // Initialize event listeners
  document.addEventListener('DOMContentLoaded', function() {
    // Reset all scroll positions
    Object.keys(scrollPositions).forEach(tabId => {
      const grid = document.getElementById(`products-${tabId}`);
      if (grid) grid.style.transform = 'translateX(0px)';
    });
    
    // Add click event listeners to tab buttons
    document.querySelectorAll('.featured-collections-tabs .tab-button').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const tabId = this.getAttribute('data-tab');
        if (tabId) {
          switchTab(tabId);
        }
      });
    });

    // Add click event listeners to arrow buttons
    document.querySelectorAll('.featured-collections-tabs .prev-arrow').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        scrollProducts('prev');
      });
    });

    document.querySelectorAll('.featured-collections-tabs .next-arrow').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        scrollProducts('next');
      });
    });
    
    // Add swipe listeners
    addSwipeListeners();
  });

  } catch(e) { console.error(e); }
})();
})();
